import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {connect} from 'react-redux';

import {RootState} from 'App/store/rootReducer';

import {SEARCH_TYPE, Bounds, CitySearch, StreetSearch} from './searchTypes';

type SearchSlice = {
  type: SEARCH_TYPE | null;
  address: string | null;
  lat: number | null;
  lng: number | null;
  street: string | null;
  bounds: Bounds | null;
  parcelId: string | null;
  contactName: string | null;
  isGeoSearchMode: boolean;
};

const initialState: SearchSlice = {
  type: null,
  address: null,
  lat: null,
  lng: null,
  street: null,
  bounds: null,
  parcelId: null,
  contactName: null,
  isGeoSearchMode: false,
};

const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    resetSearch: () => {
      return {
        ...initialState,
      };
    },
    searchCity: (_, {payload}: PayloadAction<CitySearch>) => {
      return {
        ...initialState,
        type: SEARCH_TYPE.CITY,
        address: payload.address,
        lat: payload.lat,
        lng: payload.lng,
      };
    },
    searchStreet: (_, {payload}: PayloadAction<StreetSearch>) => {
      return {
        ...initialState,
        type: SEARCH_TYPE.STREET,
        address: payload.address,
        lat: payload.lat,
        lng: payload.lng,
        street: payload.street,
        bounds: payload.bounds,
      };
    },
    searchAddress: (_, {payload}: PayloadAction<CitySearch>) => {
      return {
        ...initialState,
        type: SEARCH_TYPE.ADDRESS,
        address: payload.address,
        lat: payload.lat,
        lng: payload.lng,
      };
    },
    searchParcel: (_, {payload}: PayloadAction<string>) => {
      return {
        ...initialState,
        type: SEARCH_TYPE.PARCEL,
        parcelId: payload,
      };
    },
    searchContact: (_, {payload}: PayloadAction<string>) => {
      return {
        ...initialState,
        type: SEARCH_TYPE.CONTACT,
        contactName: payload,
      };
    },
    setIsGeoSearchMode: (state, {payload}: PayloadAction<boolean>) => {
      state.isGeoSearchMode = payload;
    },
  },
});

const mapSearchToProps = (state: RootState) => ({
  search: state.search,
});
export const connectToSearch = connect(mapSearchToProps, null, null, {
  forwardRef: true,
});

export const selectSearch = (state: RootState): SearchSlice => state.search;

export const {
  resetSearch,
  searchCity,
  searchStreet,
  searchAddress,
  searchParcel,
  searchContact,
  setIsGeoSearchMode,
} = searchSlice.actions;

export default searchSlice.reducer;
